import React, { PropTypes } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import parser from 'ua-parser-js';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import { EmailCapture, Freshchat } from 'components';
import TagManager from 'tagManager';
import RemoveTagManager from 'tagManagerRemove';

Modal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.4)';
export default class Root extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.element.isRequired,
    store: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    let incompatibleBrowserModalOpen = false;
    let ua = parser(navigator.userAgent);
    if (ua.browser.name === 'IE' && ua.browser.major <= 10) {
      incompatibleBrowserModalOpen = true;
    }

    this.state = {
      incompatibleBrowserModalOpen: incompatibleBrowserModalOpen,
      y: 0
    };

    this.renderModal = this.renderModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount () {
    this.props.history.listen((location) => {
      this.renderTagManager(location.pathname);
    });
  }

  onUpdate () {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.querySelector('html').style.height = '100%';
    }, 1);
    // Set height on html to auto before scrollTo. Otherwise it doesn't work
    // See core.scss for info on why height:100% is needed.
    document.querySelector('html').style.height = 'auto';

    const { hash } = window.location;
    if (hash !== '') {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
      }, 1000);
    }
  }

  renderModal () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.incompatibleBrowserModalOpen}
        onRequestClose={this.onCloseModal}>
        <div className='modal-content'>
          <button className='close' onClick={this.onCloseModal}></button>
          <Translate content='UNSUPPORTED_BROWSER'/>
        </div>
      </Modal>
    );
  }

  renderTagManager (pathName) {
    const googleTracking = 'googleTrackingActivitesManager';
    const pageTracking = 'trackingActivitesPage';
    if (pathName === '/activities') {
      return TagManager(googleTracking, pageTracking);
    } else {
      return RemoveTagManager(googleTracking, pageTracking);
    }
  }

  onCloseModal () {
    this.setState({
      incompatibleBrowserModalOpen: false
    });
  }

  get content () {
    return (
      <Router onUpdate={this.onUpdate} history={this.props.history}>
        {this.props.routes}
      </Router>
    );
  }

  get devTools () {
    if (__DEBUG__) {
      if (__DEBUG_NEW_WINDOW__) {
        if (!window.devToolsExtension) {
          require('../redux/utils/createDevToolsWindow').default(this.props.store);
        } else {
          window.devToolsExtension.open();
        }
      } else if (!window.devToolsExtension) {
        const DevTools = require('containers/DevTools').default;
        return <DevTools />;
      }
    }
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          {this.content}
          {this.devTools}
          {this.renderModal()}
          <EmailCapture />
          <Freshchat />
          {this.renderTagManager()}
        </div>
      </Provider>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Root.js
 **/